<ng-container *ngIf="isInitialized">
  <router-outlet></router-outlet>
</ng-container>
